import { render } from "./SwdCopyText.vue?vue&type=template&id=53271aae"
import script from "./SwdCopyText.vue?vue&type=script&lang=js"
export * from "./SwdCopyText.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__